export const ERROR_MESSAGE =
    'Could not load exceptions failures data. Refresh to try again.'

export const FETCH_FAILURE_RECORDS_LIMIT = 1000
export const PLACEMENT = 'exceptions-failures-drawer'
